import { render, staticRenderFns } from "./ChangeStatusForm.vue?vue&type=template&id=375d4634&"
import script from "./ChangeStatusForm.vue?vue&type=script&lang=js&"
export * from "./ChangeStatusForm.vue?vue&type=script&lang=js&"
import style0 from "./ChangeStatusForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports